import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import StripeConnectedConfirmation from 'components/pages/StripeConnectedConfirmation';

function mapStateToProps(state, ownProps) {
  return {
    signupReducer: state.signupReducer,
    stripeCredentialsPassed: state.paymentReducer.get('stripeCredentialsPassed')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StripeConnectedConfirmation);



// WEBPACK FOOTER //
// ./src/containers/StripeConfirmationContainer.js